/* global window */

import React, { useEffect, useRef, useState } from 'react';
import '../styles/ArticleList.css';
import ArticleListItem from './ArticleListItem';
import getArticleDescription from '../helpers/getArticleDescription';
import { array, bool } from 'prop-types';

export default function ArticleList({ isMobile, isPage = false, articles = [] }) {
    const articleListRef = useRef(null);
    const [selected, setSelected] = useState(0);
    const [isSwitching, setIsSwitching] = useState(false);
    const [startX, setStartX] = useState(0);
    const [offsetXPercent, setOffsetXPercent] = useState(0);
    const ITEMS_PER_VIEW = 1;
    const WIDTH_ADJUSTMENT = articles.length / ITEMS_PER_VIEW;
    useEffect(() => {
        /* Manual switch */
        setOffsetXPercent(0);
        const handleTouchMove = (e) => {
            if (isPage === false && isMobile === true && isSwitching === true) {
                const newX = e.touches[0].clientX;
                const articleListWidth = Math.floor(articleListRef.current.offsetWidth / articles.length);
                // Check difference
                const diffX = (newX - startX);
                const newOffsetXPercent = Math.floor(diffX / articleListWidth * 100);
                const SWITCH_DIFF_PERCENT = 15;
                if (newOffsetXPercent > SWITCH_DIFF_PERCENT) {
                    setSelected((selected - 1) >= 0 ? (selected - 1) : (articles.length - 1));
                    setIsSwitching(false);
                } else if (newOffsetXPercent <= -SWITCH_DIFF_PERCENT) {
                    setSelected((selected + 1) < articles.length ? (selected + 1) : 0);
                    setIsSwitching(false);
                } else {
                    setOffsetXPercent(newOffsetXPercent * 2.04);
                }
            }
        };
        window.addEventListener('touchmove', handleTouchMove);
        return () => {
            window.removeEventListener('touchmove', handleTouchMove);
        };
    }, [selected, isSwitching, articles, isMobile]);
    const handleTouchStart = (e) => {
        e.preventDefault();
        if (!isMobile || isPage === true) 
            return;
        setIsSwitching(true);
        setOffsetXPercent(0);
        setStartX(e.touches[0].clientX);
    };
    const handleTouchEnd = (e) => {
        if (!isMobile || isPage === true) 
            return;
        setIsSwitching(false);
    };
    return (<section
        className={'article-list--container'}>
        <ul
            ref={articleListRef}
            className={'article-list--inner' + ((isPage === true) ? ' is-page' : '')}
            style={{
                ...(isMobile && !isPage) && ({
                    width: `${WIDTH_ADJUSTMENT * 100}%`,
                    left: `${Math.floor(-(selected * (WIDTH_ADJUSTMENT / articles.length * 100)) + offsetXPercent)}%`,
                })
            }}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
        >
            {/* Article list */}
            {articles.map((article) => (
                <ArticleListItem
                    key={article.id}
                    title={article.title}
                    bodyHtml={article.bodyHtml ? getArticleDescription(article.bodyHtml) : ''}
                    imageUrl={article.imageUrl}
                    handle={article.handle}
                    isMobile={isMobile}
                    isPage={isPage}
                    articleWidth={(WIDTH_ADJUSTMENT / articles.length * 100)}
                    author={article.author}
                    createdAt={article.createdAt} />
            ))}
        </ul>
    </section>);
}

ArticleList.propTypes = {
    isMobile: bool,
    isPage: bool,
    articles: array,
};